export const environment = {
  production: true,
  ENV: "prod",
  APP_NAME: "Slip-Resistant",
  AUTH_COOKIE_NAME: "authtoken",
  BRAND_URL: "/branding",
  SERVER_URL: "/slipresistant/api",
  SURVEY_STORE_URL: "/survey-store/api",
  PERSON_UPSERT_URL: "/services/people",
  PRINTABLE_URL: "/printable/api",
  GROUP_TRACKABLES_URL: "/tracker",
  GRAPH_URL: "/graph/api",
  LD_CLIENT_ID: "645435c3a3e99a12481ad140"
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/environments/environment.ts